export const Main = (props) => {
    return <main>{props.children}</main>
}